import { deleteViewerDb } from '@/db/viewerDb'

// A delete blocked by another tab's connection can outlive any reasonable wait.
// Callers (logout, cache reset) navigate away regardless, so cap the wait instead
// of leaving the user on a dead button.
const DB_DELETE_TIMEOUT_MS = 5000

export async function clearClientState(): Promise<void> {
  try {
    localStorage.removeItem('REACT_QUERY_OFFLINE_CACHE')
    localStorage.removeItem('cmmi-viewer-app-state')
  } catch (err) {
    console.warn('[ClearClientState] failed to clear localStorage:', err)
  }

  try {
    await Promise.race([
      deleteViewerDb(),
      new Promise<void>((resolve) => setTimeout(resolve, DB_DELETE_TIMEOUT_MS)),
    ])
  } catch (err) {
    console.warn('[ClearClientState] failed to delete IndexedDB:', err)
  }
}
